<div class="flex-container-column-center height-100 bg-auth-accent">
	<div class="width-100 flex-container-row-nowrap justify-content-space-between box-sizing-border-box">
		<ic-change-language class="margin-left-auto margin-top-4px margin-right-8px color-light-gray-on-accent" />
	</div>
	@if (isAppVersionOutdated$ | async) {
		<ic-outdated-app-version-header data-test="outdated-app-version-header" />
	}
	<form class="width-100 margin-top-auto" novalidate [formGroup]="form">
		<fieldset>
			<ic-form-field class="auth__username" data-test="organisation-form">
				<span icLabel>
					{{ "auth.organisation" | translate }}
				</span>

				<input
					autocapitalize="off"
					data-test="organisation-input"
					formControlName="organisation"
					icInput
					name="organisation"
					type="text"
				/>

				<span class="fa fa-home" icPrefix></span>

				@if (hasOrganisationError) {
					<ic-error [innerHtml]="organisationErrorLabel | translate" />
				}
			</ic-form-field>

			<div class="margin-top-auto btn-wrapper" [class.loading]="loading$ | async">
				<button
					class="width-100 button-reset btn btn--primary"
					data-test="submit-button"
					type="submit"
					[disabled]="loading$ | async"
					(click)="setup(form.value)"
				>
					{{ "auth.setup" | translate }}
				</button>
				<loading-indicator class="pointer-events-none" color="#ffffff" [running]="loading$ | async" [size]="24" />
			</div>
		</fieldset>
	</form>
	<div
		class="width-100 text-align-center font-size-0-8rem color-light-gray-on-accent margin-top-auto margin-bottom-1rem"
	>
		{{ "settings.version" | translate }} {{ appVersion }}
	</div>
</div>
